import React, { useState } from "react";
import { AnimatePresence, motion } from "motion/react";
import "./styles.css";
import FloatingContainer from "../FloatingContainer";
import Slider from "../Slider";
import Button from "../Button";
import arrow from "../../../assets/img/arrow.svg";
import { selectAtoms } from "../LlmModule/utils";

const presetOptions = [
  {
    name: "=== REPRESENTATIONS ===",
    value: "none",
  },
  {
    name: "Show all atoms in CPK",
    value: "AllAtomsCPK",
  },
  {
    name: "Hide Hydrogens",
    value: "NoHs",
  },
  {
    name: "BIO preset view",
    value: "BIOnoLigands",
  },
  {
    name: "BIO including ligand coordination (slow!)",
    value: "BIO",
  },
  {
    name: "Backbones only",
    value: "Backbone",
  },
  {
    name: "Solid (all as spheres)",
    value: "Solid",
  },
  {
    name: "Very thin waters",
    value: "ThinWaters",
  },
  {
    name: "=== COLORS ONLY ===",
    value: "none",
  },
  {
    name: "Color as rainbow",
    value: "Rainbow",
  },
  {
    name: "Color by chain",
    value: "Chain",
  },
  {
    name: "Color by type",
    value: "ResType",
  },
  {
    name: "Color by Bfactor",
    value: "B-Factors",
  },
];

const VizMenu = ({
  onClose,
  scale,
  onSetScale,
  onSetAtomRadiusFactors,
  onSetAtomColors,
  onSetStickRadius,
  onMolRotationSetByValue,
  onMolRotationChange,
  pdb,
  ...props
}) => {
  const [isPresetSelectorActive, setIsPresetSelectorActive] = useState(false);
  const [presetSelection, setPresetSelection] = useState("Select a preset view");

  const handleSelectorClick = () => {
    setIsPresetSelectorActive(!isPresetSelectorActive);
  };

  const handleMolRotationSet = () => {
    let RotationsObject = {
        rotX: 0,
        rotY: 1.57,
        rotZ: 0
    };
    onMolRotationSetByValue(RotationsObject);
    console.log(RotationsObject)
  };

  const handleMolRotationChange = () => {
    let RotationsObject = {
        rotX: 0.25,
        rotY: 0.5,
        rotZ: 0
    };
    onMolRotationChange(RotationsObject);
    console.log(RotationsObject)
  };

  const handlePresetView = (previewType) => {
    if (previewType == "AllAtomsCPK") {
      const atomSelection = selectAtoms("all", pdb);
      onSetAtomColors(["cpk", atomSelection]);
      onSetAtomRadiusFactors([1, atomSelection]);
      onSetStickRadius([1, atomSelection]);
      onDisplayToast("Resetting view to balls and sticks using CPK colors.");
    } else if (previewType == "NoHs") {
      const atomSelection = selectAtoms("element H", pdb);
      onSetAtomRadiusFactors([0, atomSelection]);
      onSetStickRadius([0, atomSelection]);
    } else if (previewType == "BIOnoLigands") {
      const atomSelection = selectAtoms("all", pdb);
      onSetAtomRadiusFactors([0, atomSelection]);
      onSetStickRadius([0, atomSelection]);
      onSetAtomColors(["chain", atomSelection]);
      const atomSelection2 = selectAtoms("backbone", pdb);
      onSetAtomRadiusFactors([1, atomSelection2]);
      onSetStickRadius([2, atomSelection2]);
      onSetAtomColors(["grey", atomSelection2]);
      const atomSelection3 = selectAtoms("ligand", pdb);
      onSetAtomRadiusFactors([1, atomSelection3]);
      onSetStickRadius([1, atomSelection3]);
      onSetAtomColors(["cpk", atomSelection3]);
      const atomSelection4 = selectAtoms("ligand and element C", pdb);
      onSetAtomRadiusFactors([1, atomSelection4]);
      onSetStickRadius([1, atomSelection4]);
      onSetAtomColors(["magenta", atomSelection4]);
      const atomSelection6 = selectAtoms("water", pdb);
      onSetAtomRadiusFactors([0, atomSelection6]);
      onSetStickRadius([0, atomSelection6]);
    } else if (previewType == "BIO") {
      const atomSelection = selectAtoms("all", pdb);
      onSetAtomRadiusFactors([0, atomSelection]);
      onSetStickRadius([0, atomSelection]);
      onSetAtomColors(["chain", atomSelection]);
      const atomSelection2 = selectAtoms("backbone", pdb);
      onSetAtomRadiusFactors([1, atomSelection2]);
      onSetStickRadius([2, atomSelection2]);
      onSetAtomColors(["grey", atomSelection2]);
      const atomSelection3 = selectAtoms("ligand", pdb);
      onSetAtomRadiusFactors([1, atomSelection3]);
      onSetStickRadius([1, atomSelection3]);
      onSetAtomColors(["cpk", atomSelection3]);
      if (atomSelection3.length > 0) {
        const atomSelection4 = selectAtoms("ligand and element C", pdb);
        onSetAtomRadiusFactors([1, atomSelection4]);
        onSetStickRadius([1, atomSelection4]);
        onSetAtomColors(["magenta", atomSelection4]);
        const atomSelection5 = selectAtoms("within 5 of ligand", pdb);
        onSetAtomRadiusFactors([1, atomSelection5]);
        onSetStickRadius([1, atomSelection5]);
        onSetAtomColors(["cpk", atomSelection5]);
      }
      const atomSelection6 = selectAtoms("water", pdb);
      onSetAtomRadiusFactors([0, atomSelection6]);
      onSetStickRadius([0, atomSelection6]);
    } else if (previewType == "Backbone") {
      const atomSelection = selectAtoms("all", pdb);
      onSetAtomRadiusFactors([0, atomSelection]);
      onSetStickRadius([0, atomSelection]);
      const atomSelection2 = selectAtoms("backbone", pdb);
      onSetAtomRadiusFactors([1, atomSelection2]);
      onSetStickRadius([2, atomSelection2]);
    } else if (previewType == "ThinWaters") {
      const atomSelection = selectAtoms("water", pdb);
      onSetAtomRadiusFactors([0.1, atomSelection]);
      onSetStickRadius([0.1, atomSelection]);
    } else if (previewType == "Solid") {
      const atomSelection = selectAtoms("all", pdb);
      onSetAtomRadiusFactors([3, atomSelection]);
      onSetStickRadius([1, atomSelection]);
    } else if (previewType == "Rainbow") {
      const atomSelection = selectAtoms("protein or nucleic", pdb);
      onSetAtomColors(["rainbow", atomSelection]);
    } else if (previewType == "Chain") {
      const atomSelection = selectAtoms("all", pdb);
      onSetAtomColors(["chain", atomSelection]);
    } else if (previewType == "ResType") {
      const atomSelection2 = selectAtoms("resname ARG LYS", pdb);
      onSetAtomColors(["blue", atomSelection2]);
      const atomSelection3 = selectAtoms("resname ASP GLU", pdb);
      onSetAtomColors(["red", atomSelection3]);
      const atomSelection4 = selectAtoms("resname SER THR CYS ASN GLN GLY", pdb);
      onSetAtomColors(["green", atomSelection4]);
      const atomSelection5 = selectAtoms("resname PRO", pdb);
      onSetAtomColors(["black", atomSelection5]);
      const atomSelection6 = selectAtoms("resname HIS PHE TYR TRP", pdb);
      onSetAtomColors(["purple", atomSelection6]);
      const atomSelection7 = selectAtoms("nucleic", pdb);
      onSetAtomColors(["orange", atomSelection7]);
      const atomSelection8 = selectAtoms("ligand", pdb);
      onSetAtomColors(["cpk", atomSelection8]);
    } else if (previewType == "Bfactor") {
      const atomSelection = selectAtoms("all", pdb);
      onSetAtomColors(["bfactor", atomSelection]);
    }
  };

  return (
    <FloatingContainer offset="viz" onClose={onClose} className="viz-menu" {...props}>
      <div className="column">
        <p className="menu-title">Visualization controls</p>
        <p className="info-modal-text">Adjust visualization settings here.</p>
        <div className="menu-box-container margin-btm column">
          <Slider min={0.0} max={0.2} step={0.001} value={scale} onChange={onSetScale} label="Scale" unit="" />
          <p className="side-menu-section-header">Quickly change the view:</p>
          <div className="preset-selector row" onClick={handleSelectorClick}>
            <p>{presetSelection}</p>
            <motion.img
              src={arrow}
              width={16}
              animate={{
                rotate: isPresetSelectorActive ? 180 : 0,
              }}
              transition={{
                duration: 0.2,
                type: "spring",
                stiffness: 260,
                damping: 20,
              }}
            />
          </div>
          <p className="menu-box-text margin-btm">Hint: Use the AI assistant for finer control, with requests like "show the tryptophanes with green spheres"</p>

          <AnimatePresence>
            {isPresetSelectorActive && (
              <motion.div
                className="preset-options"
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.2 }}
              >
                {presetOptions.map((p) => {
                  return (
                    <div
                      className="preset-option"
                      key={p.name}
                      onClick={() => {
                        setPresetSelection(p.name);
                        setIsPresetSelectorActive(false);
                        handlePresetView(p.value);
                      }}
                    >
                      {p.name}
                    </div>
                  );
                })}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </div>
    </FloatingContainer>
  );
};
export default VizMenu;
